
import { fetchBrands, brandDomains } from "./brand";

let webDomain = null;
let isInitializing = false;
let initializationPromise = null;

async function loadBrands() {
  // If already initializing, return the existing promise
  if (isInitializing && initializationPromise) {
    return initializationPromise;
  }

  // If already initialized, return immediately
  if (webDomain !== null) {
    return true;
  }

  // Create the initialization promise
  initializationPromise = (async () => {
    try {
      isInitializing = true;
      await fetchBrands();
      
      // Wait for brandDomains to be populated
      let attempts = 0;
      while ((!brandDomains || Object.keys(brandDomains).length === 0) && attempts < 30) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
      
      if (!brandDomains || Object.keys(brandDomains).length === 0) {
        throw new Error('Failed to load brandDomains');
      }
      
      webDomain = getMainDomain();
      return true;
    } catch (error) {
      console.error('Error loading brands:', error);
      return false;
    } finally {
      isInitializing = false;
    }
  })();

  return initializationPromise;
}

function getMainDomain() {
  // const hostname = "enrollments.holstonacademy.org" //For testing purposes only
  // const hostname = "enrollments.pbiacademy.org" //For testing purposes only
  // const hostname = "enrollments.flexhigh.org" //For testing purposes only
  // const hostname = "enrollments.elev8schools.org" //For testing purposes only
 // const hostname = "enrollments.learn4life.org" //For testing purposes only
   const hostname = window.location.hostname.toLowerCase();
  
  if (!hostname) {
    return false;
  }
  
  const parts = hostname.split('.');
  if (hostname === "localhost") {
    return "llac";
  }
  
  // if (parts.length > 2) {
  //   // parts.shift();
	// 	return parts[parts.length - 2];
  // }
  
  // const mainDomain = parts.slice(0, -1).join('.');
	const mainDomain = parts.length >= 2 ? parts[parts.length - 2] : hostname;
  return mainDomain;
}

const findBrand = (brandName) => {
  if (!webDomain || typeof webDomain !== "string") {
    console.error("webDomain is not a valid string:", webDomain);
    return false;
  }
  
  if (!brandDomains) {
    console.error("brandDomains is not yet loaded");
    return false;
  }
  
  const urlToBrandMap = {
    stanza: brandDomains.brand_stanza?.name,
    learn4life: brandDomains.brand_learn4life?.name,
    elev8: brandDomains.brand_elev8?.name,
    flexhigh: brandDomains.brand_flexhigh?.name,
    holstonacademy: brandDomains.brand_holston?.name,
    llac: brandDomains.brand_llac?.name,
    pbiacademy: brandDomains.brand_pbia?.name,
  };
  
  const matchedBrand = Object.keys(urlToBrandMap).find((key) =>
    webDomain.includes(key)
  );
  
  return matchedBrand && urlToBrandMap[matchedBrand] === brandName;
};

// Function to get the current main domain - returns the cached value
export const getMainDomainNew = () => {
  return webDomain;
};

// Initialize on module load
loadBrands();

export { loadBrands };
export default findBrand;

export const getsites = () => {
  // console.log("webDomain1", webDomain)
  // console.log("brandDomains", brandDomains)
  
  if (!brandDomains) {
    return false;
  }
  
  const flexhigh = brandDomains.brand_flexhigh?.domain.replace(/\.[^.]+$/, "");
  const holston = brandDomains.brand_holston?.domain.replace(/\.[^.]+$/, "");
  const pbiacademy = brandDomains.brand_pbia?.domain.replace(/\.[^.]+$/, "");
  const elev8schools = brandDomains.brand_elev8?.domain.replace(/\.[^.]+$/, "");
  
  // Return corresponding brand constants or fallback
  switch (webDomain) {
    case holston:
      return brandDomains.brand_holston?.name;
    case pbiacademy:
      return brandDomains.brand_pbia?.name;
    case elev8schools:
      return brandDomains.brand_elev8?.name;
    case flexhigh:
      return brandDomains.brand_flexhigh?.name;
    default:
      return webDomain || false;
  }
};